import PredictResults from '@/trials/domain/objects/predictResults';
import PredictResult from '@/trials/domain/objects/predictResult';
import i18n from '@/common/i18n';

/**
 * 予測データを保持するクラス
 */
export default class PredictData {
    /**
     * 生データ\
     * 最後にアップロードした推論データ取得APIのレスポンスを想定しています。
     */
    private _rawData: any[];

    /**
     * 利用データ
     */
    private _data: any[];

    /**
     * ヘッダー
     */
    private _headers: any[];

    /**
     * 結果付きの予測データ
     */
    private _withResults: any[] = [];

    /**
     * コンストラクタ
     * @param rawData 生データ
     */
    constructor(rawData: any[], inputDataHeaders: any[]) {
        this._rawData = rawData;
        this._headers = inputDataHeaders;

        const data = [...rawData];
        // 同名ヘッダーがあるとサーバー側で名前に.1(ドット+数字)が付与されるので、
        // フロントでは入力データのヘッダを使用する
        data[0] = inputDataHeaders;

        this._data = data;
    }

    /**
     * getter 予測データ取得
     */
    public get data(): any[] {
        return this._data;
    }

    /**
     * getter 結果付き予測データ取得
     */
    public get dataWithResult(): any[] {
        if (this._withResults.length == 0) {
            return [];
        }

        return this._withResults;
    }

    /**
     * 結果付きの予測データのヘッダ文字列を現在のロケールに従った文字列に置換します。
     */
    public changeLocale() {
        if (!this._withResults) {
            return;
        }

        const newData = this._withResults.slice();

        newData[0][0] = i18n.t('trials.caption.results.score.result');
        newData[0][1] = i18n.t('trials.caption.results.score.score');

        this._withResults = newData;
    }

    /**
     * 結果付きの予測データ生成
     * @param results 予測結果
     */
    public createWithResult(results: PredictResults) {
        // header に 結果、スコアを追加
        const resultHeaders = [
            i18n.t('trials.caption.results.score.result'),
            i18n.t('trials.caption.results.score.score'),
        ];

        const newHeaders = resultHeaders.concat(this._headers);
        this._withResults.push(newHeaders);

        // 各行に追加
        // APIのレスポンスの項目名と表示する項目名が異なるので、ここで調整
        // API : predict     → display : result
        // API : probability → display : score

        for (let i = 1; i < this._data.length; i++) {
            const row = this._data[i];

            const result: PredictResult | null = results.fetchByIndex(i);
            if (!result) {
                continue;
            }

            const newRow = [result.predict, result.probability].concat(row);
            this._withResults.push(newRow);
        }
    }
}
